import Median from 'median-js-bridge';
import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import styled from 'styled-components';

import { Button } from '../../../../GlobalComponents/Button';
import { Flex } from '../../../../GlobalComponents/Flex';
import { Modal } from '../../../../GlobalComponents/Modal';
import { useAppSelector } from '../../../../reduxstore/hooks';
import AddBalance from '../../Cards/containers/AddBalance';

export const PrimaryCard = (): JSX.Element => {
	const [showModal, setShowModal] = useState<boolean>(false);
	const cardDetails = useAppSelector(
		state => state.accountReducer.profile.cards
	);
	const primaryCard = cardDetails.find(
		(card: Card) => card.default_payment_method
	);

	const toggleHandler = () => {
		setShowModal(!showModal);
	};

	useEffect(() => {
		Median.screen.setBrightness({
			brightness: '1.0',
			restoreOnNavigation: true
		});
		return () => {
			Median.screen.setBrightness({
				brightness: 'default',
				restoreOnNavigation: false
			});
		};
	}, []);

	return (
		<>
			{primaryCard ? (
				<>
					<Flex
						$flexDirection="column"
						$rowGap="15px"
						$padding="16px 0 20px 0"
					>
						<Flex $flexDirection="column" $rowGap="5px">
							<Flex
								$flexDirection="row"
								$columnGap="5px"
								$placeContent="center space-between"
								$alignItems="center"
							>
								<Text>Card #{primaryCard?.card_number}</Text>
								<Text>${primaryCard?.cash}</Text>
							</Flex>
							<Notes>
								Show this screen to the barista during checkout
							</Notes>
						</Flex>
						<QRContainer>
							<QRCode
								value={
									primaryCard?.card_number?.toString() ||
									'N/A'
								}
								size={240}
							/>
						</QRContainer>
					</Flex>
					<Flex
						$flexDirection="row"
						$placeContent="center"
						$alignItems="center"
					>
						<Button onClick={toggleHandler}>Add Balance</Button>
					</Flex>

					<Modal
						isOpen={showModal}
						toggleHandler={toggleHandler}
						size="lg"
					>
						<AddBalance
							onClose={() => setShowModal(false)}
							cardNumber={primaryCard.card_number}
						/>
					</Modal>
				</>
			) : (
				<Flex
					$flexDirection="column"
					$placeContent="center"
					$alignItems="center"
					$height="40vh"
				>
					<EmptyCard>No cards available!</EmptyCard>
				</Flex>
			)}
		</>
	);
};

const EmptyCard = styled.div`
	color: #000;
	font-size: 18px;
`;

const QRContainer = styled.div`
	background: #ffffff;
	padding: 24px 0;
	display: flex;
	justify-content: center;
`;

const Notes = styled.div`
	color: #000;
	font-size: 14px;
`;

const Text = styled.div`
	color: #000;
	font-size: 20px;
	font-weight: 500;
`;
